/**
 * The single source of position math. Fields are stored as PERCENTAGES of the
 * PDF page (top-left origin) — the contract shared with the backend stamper —
 * and converted to pixels only against a rendered page's bounding box.
 */

export const clampPct = (value, min = 0, max = 100) => Math.min(max, Math.max(min, value));

/** Pixel rect (relative to the rendered page) → percentage field position. */
export function boxToPct({ x, y, width, height }, pageWidth, pageHeight) {
  const posWidth = clampPct((width / pageWidth) * 100, 0.5, 100);
  const posHeight = clampPct((height / pageHeight) * 100, 0.5, 100);
  return {
    posLeft: clampPct((x / pageWidth) * 100, 0, 100 - posWidth),
    posTop: clampPct((y / pageHeight) * 100, 0, 100 - posHeight),
    posWidth,
    posHeight,
  };
}

/** Percentage field position → CSS style for an absolutely-positioned overlay box. */
export function pctToStyle(field) {
  return {
    left: `${field.posLeft}%`,
    top: `${field.posTop}%`,
    width: `${field.posWidth}%`,
    height: `${field.posHeight}%`,
  };
}

/** Round-trip helper: percentage position → pixel rect on a rendered page. */
export function pctToBox(field, pageWidth, pageHeight) {
  return {
    x: (Number(field.posLeft) / 100) * pageWidth,
    y: (Number(field.posTop) / 100) * pageHeight,
    width: (Number(field.posWidth) / 100) * pageWidth,
    height: (Number(field.posHeight) / 100) * pageHeight,
  };
}
